import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { MessageCircle, Leaf } from "lucide-react";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { brl, waLink, useSeo } from "@/lib/fmt";
import PaymentPanel from "@/components/store/PaymentPanel";
import { CartLines, Totals } from "@/components/store/CartDrawer";
import { useNavigate } from "react-router-dom";

export function CartPage() {
  const { items, pricing } = useStore();
  const nav = useNavigate();
  useSeo("Sacola");
  return (
    <div className="container-na max-w-2xl pt-10">
      <h1 className="text-4xl">Sua sacola</h1>
      {!items.length ? <p className="mt-6 text-na-ink2">Sua sacola está vazia.</p> : (
        <div className="card-na mt-6 p-6"><CartLines /><Totals pricing={pricing} /><button className="btn-na mt-5 w-full" onClick={() => nav("/checkout")} data-testid="cart-page-checkout">Fechar pedido</button></div>
      )}
    </div>
  );
}

export default function ThankYou() {
  const { id } = useParams();
  const { settings } = useStore();
  const [o, setO] = useState(null);
  useSeo("Pedido recebido");
  useEffect(() => {
    const load = () => api.get(`/orders/${id}`).then((r) => setO(r.data));
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [id]);
  if (!o) return <div className="container-na py-20">Carregando...</div>;
  return (
    <div className="container-na max-w-2xl pt-10">
      <div className="card-na p-8 text-center">
        <Leaf className="mx-auto h-10 w-10 text-na-gold" />
        <h1 className="mt-4 text-4xl">Pedido recebido</h1>
        <p className="mt-2 text-na-ink2">Número do pedido <b className="text-na-ink" data-testid="order-number">{o.numero}</b> · Total <b data-testid="order-total">{brl(o.total)}</b></p>
        <div className="mt-6 text-left"><PaymentPanel order={o} /></div>
        <a href={waLink(settings?.whatsapp_e164 || "5531987686700", o.whatsapp_texto)} target="_blank" rel="noreferrer" className="btn-wa mt-6 w-full" data-testid="send-order-whatsapp"><MessageCircle className="h-4 w-4" /> Enviar pedido no WhatsApp</a>
        <Link to="/" className="btn-line mt-3 w-full">Voltar para a loja</Link>
      </div>
    </div>
  );
}
